import { render, staticRenderFns } from "./Typeform.vue?vue&type=template&id=a70e83d8&"
import script from "./Typeform.vue?vue&type=script&lang=js&"
export * from "./Typeform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports